export const init = () => {
  const sep = AnalyticsConstants.concatenator;
  const fwk = CUBE.Analytics;
  const utils = fwk.utils;

  const classProductViewed = 'viewed';
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.product.panoply
  );

  const getProductLabel = () => {
    const productName = tc_vars.product_label_displayed;
    const modelId = utils.productpage.getSelectedModelId();
    return productName + sep + modelId;
  };
  const getPrice = () => utils.productpage.getSelectedPrice();

  const arrowLeftPanoply = new AnalyticsClickEvent(
    'arrowLeftPanoply',
    tracker.defaultEvent()
  );
  arrowLeftPanoply.options.action =
    AnalyticsConstants.slick.defaultValueArrowLeft;
  arrowLeftPanoply.domElement = '#product-bundles .slick-prev';
  arrowLeftPanoply.getLabel = getProductLabel;
  arrowLeftPanoply.getValue = getPrice;
  arrowLeftPanoply.postAction($element => {
    let indexPanoply = $('#product-bundles .slick-slide.slick-active').index();
    if (indexPanoply === -1) {
      indexPanoply = 0;
    }
    sendImpressionPanoply(indexPanoply, $element);
  });
  tracker.addEvent(arrowLeftPanoply);

  const arrowRightPanoply = new AnalyticsClickEvent(
    'arrowRightPanoply',
    tracker.defaultEvent()
  );
  arrowRightPanoply.options.action =
    AnalyticsConstants.slick.defaultValueArrowRight;
  arrowRightPanoply.domElement = '#product-bundles .slick-next';
  arrowRightPanoply.getLabel = getProductLabel;
  arrowRightPanoply.getValue = getPrice;
  arrowRightPanoply.postAction($element => {
    let indexPanoply = $('#product-bundles .slick-slide.slick-active').index();
    if (indexPanoply === -1) {
      indexPanoply = 0;
    }
    sendImpressionPanoply(indexPanoply, $element);
  });
  tracker.addEvent(arrowRightPanoply);

  const getAction = element =>
    AnalyticsConstants.slick.defaultValuePagination +
    (element
      .parent()
      .find(element)
      .index() +
      1);

  const paginationPanoply = new AnalyticsClickEvent(
    'paginationPanoply',
    tracker.defaultEvent()
  );
  paginationPanoply.getAction = getAction;
  paginationPanoply.domElement = '#product-bundles .slick-dots li';
  paginationPanoply.getLabel = getProductLabel;
  paginationPanoply.getValue = getPrice;
  paginationPanoply.postAction($element => {
    const indexPanoply = $element
      .parent()
      .find($element)
      .index();
    sendImpressionPanoply(indexPanoply, $element);
  });
  tracker.addEvent(paginationPanoply);

  // ClickPanoplyProduct
  const clickPanoplyProduct = new AnalyticsClickEvent(
    'ClickPanoplyProduct',
    tracker.defaultEvent()
  );

  clickPanoplyProduct.options.action = 'ClickPanoplyProduct';
  clickPanoplyProduct.domContainer = '#modal-product-bundles';
  clickPanoplyProduct.domElement = '.msb__data a';
  clickPanoplyProduct.getLabel = function($element) {
    const product = $element.closest('.msb__product');
    return (
      product
        .find('.msb__name')
        .text()
        .trim() +
      sep +
      product.find('.msb__color[data-class=current]').data('modelId')
    );
  };
  clickPanoplyProduct.getValue = function($element) {
    return $element
      .closest('.msb__product')
      .find('.dkt-price__cartridge[data-price]')
      .data('price');
  };
  tracker.addEvent(clickPanoplyProduct);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

  const sendImpressionPanoply = (indexPanoply, $element) => {
    let selector = '.slick-active .pb-el__product';
    if ($(selector).length === 0) {
      selector = '.pb-el__products .pb-el__product';
    }
    $(selector).each(function() {
      setProductPanoplyAsViewed(indexPanoply, $(this));
    });
  };

  const setProductPanoplyAsViewed = (indexPanoply, $product) => {
    if (utils.isVisible($product) && !$product.hasClass(classProductViewed)) {
      const model = utils.productpage.getPanoplyModel(
        indexPanoply,
        $product.data('productid'),
        'SM'
      );
      fwk.enhanced.sendImpression(model);
      $product.addClass(classProductViewed);
    }
  };
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/panoply-tracker.js